import planningElementsDefault from './planningElements.json'
import intl from 'react-intl-universal'

export default ['$scope', '$rootScope', PlanningBodyController]

function PlanningBodyController($scope, $rootScope) {
  this.articleDetails = intl.get('PlanningBody.articleDetails')
  this.elements =
    window.org_settings &&
    window.org_settings.v2 &&
    window.org_settings.v2.planning
      ? window.org_settings.v2.planning
      : planningElementsDefault
  this.userRolesAuth = window.userRolesAuth
}
